<template>
  <div>
    <div v-if="loading">
      <px-circular-loading/>
    </div>
    <div v-if="!loading && itemAprovacao">
      <px-aprovacao-solicitacao-detalhes-produto-dados-basicos :item-aprovacao="itemAprovacao"/>
      <px-aprovacao-solicitacao-detalhes-produto-compras v-if="itemAprovacao.produto"
                                                         :item-aprovacao="itemAprovacao"/>
      <px-aprovacao-solicitacao-detalhes-produto-cotacoes v-if="itemAprovacao.produto"
                                                          :item-aprovacao="itemAprovacao"/>
      <px-aprovacao-solicitacao-produto-aprovadores :item-aprovacao="itemAprovacao" />
    </div>
  </div>
</template>

<script>
import AprovacaoSolicitacaoDetalhesProdutoDadosBasicos
  from '@/modules/aprovacao-solicitacao/detalhes-produtos/AprovacaoSolicitacaoDetalhesProdutoDadosBasicos.vue';
import AprovacaoSolicitacaoDetalhesProdutoCompras
  from '@/modules/aprovacao-solicitacao/detalhes-produtos/AprovacaoSolicitacaoDetalhesProdutoCompras.vue';
import AprovacaoSolicitacaoDetalhesProdutoCotacoes
  from '@/modules/aprovacao-solicitacao/detalhes-produtos/AprovacaoSolicitacaoDetalhesProdutoCotacoes.vue';
import AprovacaoSolicitacaoService from '@/modules/aprovacao-solicitacao/aprovacao-solicitacao-service';
import AprovacaoSolicitacaoProdutoAprovadores
  from '@/modules/aprovacao-solicitacao/components/AprovacaoSolicitacaoProdutoAprovadores.vue';

export default {
  props: {
    aprovacaoIdProp: {
      type: [String, Number],
    },
    itemIdProp: {
      type: [String, Number],
    },
  },
  data() {
    return {
      loading: false,
      aprovacaoId: null,
      itemId: null,
      itemAprovacao: null,
    };
  },
  methods: {
    getAprovacaoProduto() {
      this.loading = true;
      AprovacaoSolicitacaoService.getProduto(this.aprovacaoId, this.itemId)
        .then(({ data }) => {
          this.itemAprovacao = data;
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
  created() {
    this.aprovacaoId = this.aprovacaoIdProp || this.$route.params.id;
    this.itemId = this.itemIdProp;
    this.getAprovacaoProduto();
  },
  components: {
    pxAprovacaoSolicitacaoDetalhesProdutoDadosBasicos:
    AprovacaoSolicitacaoDetalhesProdutoDadosBasicos,
    pxAprovacaoSolicitacaoDetalhesProdutoCompras: AprovacaoSolicitacaoDetalhesProdutoCompras,
    pxAprovacaoSolicitacaoDetalhesProdutoCotacoes: AprovacaoSolicitacaoDetalhesProdutoCotacoes,
    pxAprovacaoSolicitacaoProdutoAprovadores: AprovacaoSolicitacaoProdutoAprovadores,
  },
};
</script>
